import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { reportHubPreviewLocation, setHubPreviewNavigator } from "./hubPreview";

/** Inside the Hub's preview: lets the Hub switch dashboard pages and tells it which page is showing. */
export function HubPreviewRouteSync() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    setHubPreviewNavigator((path) => navigate(path));
    return () => setHubPreviewNavigator(null);
  }, [navigate]);

  useEffect(() => {
    reportHubPreviewLocation(pathname);
  }, [pathname]);

  return null;
}
